/* eslint-disable-next-line no-restricted-imports */
import * as t from 'io-ts';

const tBoostMenuStore = t.type({
  id: t.number,
  name: t.string,
  city: t.union([t.string, t.null]),
  state: t.union([t.string, t.null]),
  status: t.string,
  photo: t.union([t.string, t.null]),
});

const tBoostMenuIntegrationDetails = t.union([
  t.type({
    type: t.literal('wordpress'),
    partner_menu_url: t.union([t.string, t.null]),
    partner_hosted_path: t.union([t.string, t.null]),
  }),
  t.type({
    type: t.literal('subdomain'),
    host: t.union([t.string, t.null]),
    path: t.union([t.string, t.null]),
    published_template_url: t.union([t.string, t.null]),
    published_template_auto_import: t.union([t.boolean, t.null]),
    published_template_html_updated_at: t.union([t.string, t.null]),
    content_selector: t.union([t.string, t.null]),
  }),
  t.type({
    type: t.literal('reverse_proxy'),
    url: t.union([t.string, t.null]),
    published_template_url: t.union([t.string, t.null]),
    published_template_auto_import: t.union([t.boolean, t.null]),
    published_template_html_updated_at: t.union([t.string, t.null]),
    content_selector: t.union([t.string, t.null]),
  }),
  t.type({
    type: t.literal('static'),
  }),
]);

const tBoostMenu = t.type({
  id: t.number,
  enabled: t.boolean,
  integration_method: t.union([
    t.literal('wordpress'),
    t.literal('subdomain'),
    t.literal('reverse_proxy'),
    t.literal('static'),
  ]),
  created_at: t.number,
  updated_at: t.number,
  store: tBoostMenuStore,
  integration_details: tBoostMenuIntegrationDetails,
  partner_menu_url: t.union([t.string, t.null]),
  sitemap_url: t.union([t.string, t.null]),
});

export const tBoostMenusResponse = t.type({
  boost_menus: t.array(tBoostMenu),
});

export type BoostMenu = t.TypeOf<typeof tBoostMenu>;
export type BoostMenusResponse = t.TypeOf<typeof tBoostMenusResponse>;
